import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Delivery } from "../../../../services/Delivery";

export const useDeliveryHorariosDisponiveis = (
  uuidDelivery: string,
  dataAgendamento: string,
) => {
  const query = useQuery({
    queryKey: ["delivery-horarios-disponiveis", uuidDelivery, dataAgendamento],
    queryFn: () =>
      Delivery.getHorariosDisponiveis({ uuidDelivery, dataAgendamento }),
    select: (response) => response.data,
    enabled: !!uuidDelivery && !!dataAgendamento,
  });

  useEffect(() => {
    if (!query.isError) return;

    const {
      response: {
        data: { mensagem },
      },
    } = query.error as any;

    toast.error(mensagem);
  }, [query.isError]);

  return query;
};
